import { shallowEqual, TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { applyMiddleware, combineReducers, createStore, Store } from 'redux';
import thunk, { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { creators as assetCreators, reducer as assetReducer } from './asset/asset';
import { creators as assetListCreators, reducer as assetListReducer } from './asset/list';
import { creators as assetLogsCreators, reducer as assetLogsReducer } from './asset/logs';
import { creators as asset_typeCreators, reducer as asset_typeReducer } from './asset/type';
import { creators as cancelCreators, reducer as cancelReducer } from './cancel';
import { creators as eventCreators, reducer as eventReducer } from './global/event';
import { creators as global_sidebarCreators, reducer as global_sidebarReducer } from './global/sidebar';
import { creators as plan_activityCreators, reducer as plan_activityReducer } from './plan/activity';
import {
    creators as plan_damageMechanismCreators,
    reducer as plan_damageMechanismReducer,
} from './plan/damageMechanism';
import { creators as planCreators, reducer as planReducer } from './plan/plan';
import { creators as planProjectsCreators, reducer as planProjectsReducer } from './plan/projects';
import { creators as plan_referenceCreators, reducer as plan_referenceReducer } from './plan/reference';
import { creators as projectCalendarCreators, reducer as projectCalendarReducer } from './project/calendar';
import { creators as project_categoryCreators, reducer as project_categoryReducer } from './project/category';
import { creators as project_listCreators, reducer as project_listReducer } from './project/list';
import { creators as projectCreators, reducer as projectReducer } from './project/project';
import { creators as reportListCreators, reducer as reportListReducer } from './report/list';
import { creators as reportCreators, reducer as reportReducer } from './report/report';
import { creators as statsCreators, reducer as statsReducer } from './stats';
import { creators as userCreators, reducer as userReducer } from './user';

export const actions = {
    asset_list: assetListCreators,
    asset_type: asset_typeCreators,
    asset: assetCreators,
    assetLogs: assetLogsCreators,
    cancel: cancelCreators,
    event: eventCreators,
    global_sidebar: global_sidebarCreators,
    plan_activity: plan_activityCreators,
    plan_damageMechanism: plan_damageMechanismCreators,
    plan_reference: plan_referenceCreators,
    plan: planCreators,
    planProjects: planProjectsCreators,
    project_category: project_categoryCreators,
    project_list: project_listCreators,
    project: projectCreators,
    projectCalendar: projectCalendarCreators,
    report: reportCreators,
    report_list: reportListCreators,
    stats: statsCreators,
    user: userCreators,
};

const reducers = {
    asset_list: assetListReducer,
    asset_type: asset_typeReducer,
    asset: assetReducer,
    assetLogs: assetLogsReducer,
    cancel: cancelReducer,
    event: eventReducer,
    global_sidebar: global_sidebarReducer,
    plan_activity: plan_activityReducer,
    plan_damageMechanism: plan_damageMechanismReducer,
    plan_reference: plan_referenceReducer,
    plan: planReducer,
    planProjects: planProjectsReducer,
    project_category: project_categoryReducer,
    project_list: project_listReducer,
    project: projectReducer,
    projectCalendar: projectCalendarReducer,
    report: reportReducer,
    report_list: reportListReducer,
    stats: statsReducer,
    user: userReducer,
};

const combineReducer = combineReducers(reducers);
export type StoreState = ReturnType<typeof combineReducer>;
export type StoreAction = Parameters<typeof combineReducer>[1];
export type AsyncDispatch = ThunkDispatch<StoreState, void, StoreAction>;
export type AsyncAction = ThunkAction<Promise<void>, StoreState, void, StoreAction>;
export type AsyncStore = Store<StoreState, StoreAction> & { dispatch: AsyncDispatch };

export const store: AsyncStore = createStore(combineReducers(reducers), applyMiddleware(thunk));
export const useTypedDispatch: () => Parameters<AsyncAction>[0] = useDispatch;
export const useTypedSelector: TypedUseSelectorHook<StoreState> = selector => useSelector(selector, shallowEqual);
